/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanFrameActionPlusIcon16Light } from './ScanFrameActionPlusIcon16Light';
import { ScanFrameActionPlusIcon16Regular } from './ScanFrameActionPlusIcon16Regular';
import { ScanFrameActionPlusIcon16Solid } from './ScanFrameActionPlusIcon16Solid';
import { ScanFrameActionPlusIcon20Light } from './ScanFrameActionPlusIcon20Light';
import { ScanFrameActionPlusIcon20Regular } from './ScanFrameActionPlusIcon20Regular';
import { ScanFrameActionPlusIcon20Solid } from './ScanFrameActionPlusIcon20Solid';
import { ScanFrameActionPlusIcon24Regular } from './ScanFrameActionPlusIcon24Regular';
import { ScanFrameActionPlusIcon24Solid } from './ScanFrameActionPlusIcon24Solid';
import { ScanFrameActionPlusIcon32Regular } from './ScanFrameActionPlusIcon32Regular';
import { ScanFrameActionPlusIcon64Regular } from './ScanFrameActionPlusIcon64Regular';
var sizes = {
    16: {
        light: ScanFrameActionPlusIcon16Light,
        regular: ScanFrameActionPlusIcon16Regular,
        solid: ScanFrameActionPlusIcon16Solid,
    },
    20: {
        light: ScanFrameActionPlusIcon20Light,
        regular: ScanFrameActionPlusIcon20Regular,
        solid: ScanFrameActionPlusIcon20Solid,
    },
    24: {
        regular: ScanFrameActionPlusIcon24Regular,
        solid: ScanFrameActionPlusIcon24Solid,
    },
    32: {
        regular: ScanFrameActionPlusIcon32Regular,
    },
    64: {
        regular: ScanFrameActionPlusIcon64Regular,
    },
};
export var ScanFrameActionPlusIcon = forwardRef('ScanFrameActionPlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
